import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { dataBound } from '@syncfusion/ej2-angular-grids';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ErrorService } from 'src/app/error.service';
import { GetTaxBO, saveTimesheetBO, TimesheetBO } from '../timesheet.modal';

@Injectable({
  providedIn: 'root'
})
export class TimesheetEditService {

  constructor(private http: HttpClient, public errorService: ErrorService,
  ) {}
  getActiveAuthsWithinDateRange(params: URLSearchParams): Observable<any> {
    let url = "api/ClientAuthorization/getActiveAuthsWithinDateRange?";
    return this.http.get<any>(url +params, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }
  saveTimesheet(saveTimesheets: TimesheetBO): Observable<any> {
    let url = "api/Timesheets/SaveUpdateTimeSheet";
    // let url=""
    return this.http.post(url, saveTimesheets, { observe: 'response',responseType: "text" }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  checkHoursExceed(checkHoursExceeds: TimesheetBO): Observable<any> {
    let url = "api/Timesheets/OverTimeExceed";
    return this.http.post(url, checkHoursExceeds, { observe: 'response'}).pipe(
      map(data => {
        console.log("Data body.........:", data.body);  
        return data.body
  }),
      catchError(this.errorService.handleError)
    )
  }

  // checkHoursExceed(hoursCheckPayload: any): Observable<any> {
  //   let url = "";
  //   return this.http.post(url, hoursCheckPayload, { observe: 'response'}).pipe(
  //     map(data => data.body),
  //     catchError(this.errorService.handleError)
  //   )
  // }
 

  checkTimesheets(params: URLSearchParams): Observable<any> {
    let url = "api/Timesheets/checkTimesheets?";
    return this.http.get<any>(url +params, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }
  GetEmployeePayrateForClient(params: URLSearchParams): Observable<any> {
    let url = "api/EmployeePayrate/GetEmployeePayrateForClient?";
    return this.http.get<any>(url +params, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }


  getTaxListDetails(SaveTimesheetBO:GetTaxBO):Observable<any> {
    let url = "api/Timesheets/GetEmployerTaxdetails"

    return this.http.post(url,SaveTimesheetBO,{observe: 'response'}).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }


  

  
}
